import { endPoints } from 'api/';
import { GET_ORDER_SETTINGS } from 'actions/types';

/**
 * @description Get company default order settings.
 * @param {string} companyId Current user's company id.
 */
export function getOrderSetting(companyId) {
  const query = { where: { company_id: companyId } };
  /**
   * @param {Function} dispatch
   */
  return function (dispatch) {
    const action = {
      type: GET_ORDER_SETTINGS,
      /**
       * @param {Function} apiClient
       */
      request: async function (apiClient) {
        return await apiClient(endPoints.GET_ORDER_SETTINGS, {}, query);
      },
    };
    dispatch(action);
  };
}
